import { useEffect, useState } from "react";
import { BiCalendarPlus } from "react-icons/bi";
import { useLocation, useNavigate } from "react-router-dom";
import { HashLoader } from "react-spinners";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";

import { Navbar } from "../../components/Navbar/index";
import Modal from "../../views/Modal";
import { COLORS } from "../../utils/colors";
import { MainButton } from "../../components/MainButton";
import { AuthenticationView } from "../Authentication";
import { useDispatch } from "react-redux";
import { resetMainState, setSession } from "../../store/mainReducer";
import { ICONS } from "../../utils/icons";

export const Page = ({
  supabase,
  handleSnackbar,
  userData,
  session,
  children,
}) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const currentPath = location.pathname;
  const [pathObject, setPathObject] = useState({});
  const [openMobileDialog, setOpenMobileDialog] = useState(
    window.innerWidth < 1100 ? true : false
  );
  const hidePageTitle =
    currentPath !== "/create-event" &&
    currentPath !== "/organization" &&
    currentPath !== "/events" &&
    currentPath !== "/" &&
    currentPath !== "/create-event";

  const pageTitles = {
    "/": {
      title: "Welcome!",
      subTitle: "Live overview of your ticketing.",
    },
    "/events": {
      title: "Events",
      subTitle: "List of all events organized by you.",
      button: (
        <MainButton
          text={"Create Event"}
          color={COLORS.black}
          shadowColor={"transparent"}
          textColor={COLORS.white}
          textHoverColor={COLORS.grey2}
          hoverColor={COLORS.black}
          textAlignment={"left"}
          onClickAction={() => navigate("/create-event")}
        >
          <BiCalendarPlus size={20} color={COLORS.white} />
        </MainButton>
      ),
    },
    "/create-event": {
      title: "Create Event",
      subTitle: "Create a new event.",
    },
    "/organization": {
      title: "Organization",
      subTitle:
        "Manage all things about your organization, operators, memberships and more.",
      button: (
        <MainButton
          disabled={loading}
          text={
            loading ? (
              <>
                <HashLoader size={20} color={COLORS.lightRed} /> Log out
              </>
            ) : (
              "Log out"
            )
          }
          onClickAction={() => handleLogout()}
          color={COLORS.red}
          textColor={COLORS.white}
          textHoverColor={COLORS.lightRed}
          hoverColor={COLORS.red}
          shadowColor={COLORS.red}
          width={"fit-content"}
        />
      ),
    },
  };

  useEffect(async () => {
    try {
      const { data, error } = await supabase.auth.getSession();

      if (error) {
        console.log("error: ", error);
      }

      if (data) {
        dispatch(setSession(data.session));
      }
    } catch (error) {
      console.log("error: ", error);
      handleSnackbar(
        "Something went wrong, please try again later and get in touch if the error persists!",
        "error"
      );
    }
  }, []);

  useEffect(() => {
    switch (currentPath) {
      case "/":
        setPathObject(pageTitles["/"]);
        break;
      case "/events":
        setPathObject(pageTitles["/events"]);
        break;
      case "/create-event":
        setPathObject(pageTitles["/create-event"]);
        break;
      case "/organization":
        setPathObject(pageTitles["/organization"]);
        break;
      default:
        break;
    }
  }, [currentPath]);

  const handleLogout = async () => {
    try {
      setLoading(true);
      const { error } = await supabase.auth.signOut();

      window.localStorage.clear();
      dispatch(resetMainState());

      if (error) {
        console.log("error: ", error);
      }

      navigate("/");
      setLoading(false);
    } catch (error) {
      console.log("error: ", error);
    }
  };

  return (
    <div id="page">
      <Dialog open={openMobileDialog}>
        <DialogContent>
          <h2 style={{ marginBottom: "5px", fontSize: "23px" }}>
            {ICONS.warningBlack25} Limited mobile support
          </h2>
          <p>
            The current OOVAL Backoffice is only availble on big screen devices.
            We promise we are working on bringing the fully fledged product to
            mobile!
          </p>
          {/* <DialogActions>
            <MainButton
              color={COLORS.black}
              shadowColor={"transparent"}
              textColor={COLORS.white}
              textHoverColor={COLORS.lightGrey}
              hoverColor={COLORS.black}
              textAlignment={"center"}
              onClickAction={() => handleClose()}
              width={"fit-content"}
            >
              {"Continue"}
            </MainButton>
          </DialogActions> */}
        </DialogContent>
      </Dialog>
      <div id="page-container">
        {!session || currentPath === "/new-password" ? (
          <AuthenticationView supabaseClient={supabase} />
        ) : (
          <>
            <Navbar userData={userData} handleSnackbar={handleSnackbar} />
            <div id="page-content">
              <div id="page-card">
                {!hidePageTitle && (
                  <div className="page-title">
                    <div>
                      <h1>{pathObject.title}</h1>
                      <p id="subTitle">{pathObject.subTitle}</p>
                    </div>
                    <div>{pathObject.button}</div>
                  </div>
                )}
                {children}
              </div>
            </div>
          </>
        )}
        <Modal />
      </div>
    </div>
  );
};
